import React, { Component } from "react";
import { PropTypes } from "prop-types";

import "css/common/switch-onoff.scss";

class SwitchOnOff extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checked: this.props.checked || false,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.checked !== prevProps.checked) {
      this.setState({
        checked: this.props.checked,
      });
    }
  }

  onChange = (e) => {
    this.props.onChange(!this.state.checked, e);

    this.setState({
      checked: !this.state.checked,
    });
  };

  render() {
    const { name, iconName = "", size = "sm", disabled, label } = this.props;

    return (
      <div
        className={`switch-onoff-container switch-onoff-${size}`}
        onClick={(e) => e.stopPropagation()}
      >
        <input
          id={name}
          name={name}
          type="checkbox"
          disabled={disabled}
          checked={this.state.checked}
          onChange={this.onChange}
        />
        <label
          htmlFor={name}
          className={
            (this.state.checked ? "onOff-toggled " : " ") +
            (label ? "labeled" : "")
          }
        >
          <span className="onoff-toggler">
            <i className="material-icons">{iconName}</i>
          </span>
          {label}
        </label>
      </div>
    );
  }
}

SwitchOnOff.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  iconName: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  size: PropTypes.string.isRequired,
};

export default SwitchOnOff;
